var chipValue = 'fx_e395032e_1gfft351';
var chipValueHorizontalGap = 'var(--fx_e395032e_1gfft350)';

export { chipValue, chipValueHorizontalGap };
//# sourceMappingURL=value.vanilla.mjs.map
